export default __webpack_public_path__ + "static/media/volume-up.353e63f4.svg";